import { DateTime } from 'luxon';

const appVersion = DateTime.fromISO(process.env.REACT_APP_BUILD_DATE, {
  zone: 'America/Sao_Paulo',
}).toFormat('yyyy.MM.dd.HH.mm');

const appCommit = process.env.REACT_APP_COMMIT;

export { appVersion, appCommit };
